/* eslint no-undef: 'off' */
import $ from "jquery";
// import call_ajax from "../helpers/ajax";

const init = () => {
  customLogin();
};

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function customLogin() {
  let lang = getCookie("wp-wpml_current_language");
  $(".showlogin").attr("href", "/" + lang + "/login");
}

try {
  init();
} catch (error) {
  console.error();
}
